module.exports = __webpack_public_path__ + "img/img-ae0883f6.785c3a17.png";